module.exports = __webpack_public_path__ + "img/hd_05.0dca43d3.png";